import { AlertTriangle, Smartphone, Monitor, LogOut } from 'lucide-react'
import { useUser } from '../contexts/UserContext'
import { motion, AnimatePresence } from 'framer-motion'

export function SessionConflictModal() {
    const { sessionConflict, resolveSessionConflict } = useUser()

    if (!sessionConflict) return null

    const { deviceType, lastActive } = sessionConflict
    const lastActiveDate = new Date(lastActive).toLocaleString('pt-BR')

    return (
        <AnimatePresence>
            <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
                <motion.div
                    {...({
                        initial: { opacity: 0, scale: 0.95 },
                        animate: { opacity: 1, scale: 1 },
                        exit: { opacity: 0, scale: 0.95 }
                    } as any)}
                    className="bg-white dark:bg-zinc-900 rounded-2xl shadow-2xl max-w-md w-full overflow-hidden border border-gray-200 dark:border-zinc-800"
                >
                    <div className="p-6">
                        <div className="flex items-center gap-4 mb-6">
                            <div className="w-12 h-12 rounded-full bg-yellow-100 dark:bg-yellow-900/30 flex items-center justify-center shrink-0">
                                <AlertTriangle className="w-6 h-6 text-yellow-600 dark:text-yellow-500" />
                            </div>
                            <div>
                                <h2 className="text-xl font-bold text-gray-900 dark:text-white">
                                    Limite de Dispositivos
                                </h2>
                                <p className="text-sm text-gray-500 dark:text-gray-400">
                                    Conflito de sessão detectado
                                </p>
                            </div>
                        </div>

                        <div className="bg-gray-50 dark:bg-zinc-800/50 rounded-xl p-4 mb-6 border border-gray-100 dark:border-zinc-800">
                            <p className="text-gray-700 dark:text-gray-300 mb-3">
                                Você já está conectado em outro dispositivo <strong>{deviceType === 'mobile' ? 'Mobile' : 'Desktop'}</strong>.
                            </p>

                            <div className="flex items-center gap-3 text-sm text-gray-500 dark:text-gray-400">
                                {deviceType === 'mobile' ? <Smartphone className="w-4 h-4" /> : <Monitor className="w-4 h-4" />}
                                <span>Ativo pela última vez em: {lastActiveDate}</span>
                            </div>
                        </div>

                        <p className="text-gray-600 dark:text-gray-400 text-sm mb-6">
                            Para continuar aqui, você precisa desconectar o outro dispositivo.
                        </p>

                        <div className="flex gap-3">
                            <button
                                onClick={() => resolveSessionConflict('cancel')}
                                className="flex-1 px-4 py-2.5 rounded-xl border border-gray-200 dark:border-zinc-700 text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-50 dark:hover:bg-zinc-800 transition-colors"
                            >
                                Cancelar Login
                            </button>
                            <button
                                onClick={() => resolveSessionConflict('replace')}
                                className="flex-1 px-4 py-2.5 rounded-xl bg-blue-600 text-white font-medium hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
                            >
                                <LogOut className="w-4 h-4" />
                                Desconectar Outro
                            </button>
                        </div>
                    </div>
                </motion.div>
            </div>
        </AnimatePresence>
    )
}
